import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';
import { ReCaptcha } from 'react-recaptcha-v3'

export default class ShareFavourites extends Component {

    static propTypes = {
        sendFavouritesEmail: PropTypes.func,
        siteKey: PropTypes.string,
        clearFlashMessages: PropTypes.func,
        shareButtonLabel: PropTypes.string
    };

    recaptcha;

    initialState = {
        showShareForm: false,
		shareEmail: '',
        validEmail: false,
        emailTouched: false,
        recaptchaToken: ''
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    onChange = (event) => {
    	this.setState(
    	    {shareEmail: event.target.value},
            () => {
    	        this.setState({validEmail: this.isValidEmail(this.state.shareEmail)})
            });
	};

    onBlur = () => {
        this.setState({emailTouched: true});
    };

    toggleForm = () => {
        this.setState({showShareForm: !this.state.showShareForm})
    };

    verifyCallback = (recaptchaToken) => {
        this.setState({recaptchaToken: recaptchaToken});
    };

    resetForm = () => {
        this.setState({
            shareEmail: '',
            validEmail: false,
            emailTouched: false,
        });
        this.recaptcha.execute();
    };

    render() {

    	const {showShareForm, shareEmail, validEmail, emailTouched, recaptchaToken} = this.state;
    	const {sendFavouritesEmail, siteKey, clearFlashMessages, shareButtonLabel} = this.props;

		return (
			<div className='shareFavouritesContainer'>
                <div className='shareButtonContainer'>
                    <button onClick={this.toggleForm}>
                        {translate(shareButtonLabel)}
                    </button>
                </div>
				{showShareForm &&
					<div className='shareEmailFormFieldContainer'>
                        <ReCaptcha
                            sitekey={siteKey}
                            ref={el => { this.recaptcha = el; }}
                            action='share_favourites'
                            verifyCallback={this.verifyCallback}
                        />
						<input name='shareEmail' value={shareEmail} placeholder={translate('itinerary_favourites.email.input.placeholder')} onChange={this.onChange} onBlur={this.onBlur} onFocus={() => clearFlashMessages()} />
                        {emailTouched &&!validEmail &&
                            <span className='errorMessage'>
                                {translate('itinerary_favourites.invalid_email')}
                            </span>
                        }
                        <button onClick={() => sendFavouritesEmail(shareEmail, recaptchaToken, this.resetForm)} disabled={!validEmail}>
                            {translate('itinerary_favourites.send_email_button')}
                        </button>
					</div>
				}
			</div>
		);
	}

    isValidEmail = email => {
        const validEmailRegex =
            new RegExp(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i);

        return email !== '' && validEmailRegex.test(email);
    }
}



// WEBPACK FOOTER //
// ./src/components/Favourites/ShareFavourites.js